export const changeTab = ({ payload }) => {
  return {
    type: "CHANGE_TAB",
    payload: payload,
  };
};
